<template>
    <v-container class="pl-0">
        <entity-nav :navItems="navItems" useEvents></entity-nav>
        <div class="entityView">
            <keep-alive exclude="RitualCircleReader">
                <router-view></router-view>
            </keep-alive>
        </div>
    </v-container>
</template>
<script>
import EntityNav from '../../components/EntityNav.vue'
import { mapState } from 'vuex'
import permissionsSet from '../../components/permissions'
const entity = 'ritual'
export default {
    name: 'RitualCircleHome',
    components: {
        'entity-nav': EntityNav,
    },
    computed: {
        ...mapState(['user']),
        navItems() {
            let items = [
                { title: 'List', icon: 'mdi-view-list', to: 'ritualCircle' },
                { title: 'Archive', icon: 'mdi-delete-outline', to: 'ritualCircleArchive' },
            ]
            if (this.canCreate) items = [{ title: 'New', icon: 'mdi-plus', to: 'newRitualCircle' }, ...items]

            return items
        },
        canCreate() {
            console.log(this.user)
            if (this.user && this.user[entity]) {
                return this.user[entity].owned.includes(permissionsSet.Create)
            } else {
                return false
            }
        },
    },
}
</script>
<style>
.entityView {
    width: 100%;
}
</style>
